// extracted by mini-css-extract-plugin
export default {"Placeholder":"NkRDhtq0"};